var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c("div", { staticClass: "boss-layout-block" }, [
        _c("dl", { staticClass: "boss-scout-send-wrap cleafix" }, [
          _c("dt", { staticClass: "boss-scout-send-left" }, [
            _vm._v("テンプレート"),
          ]),
          _vm._v(" "),
          _c("dd", { staticClass: "boss-scout-send-right" }, [
            _c(
              "select",
              {
                staticClass: "boss-input-select",
                domProps: { value: _vm.selectedTemplateId },
                on: {
                  change: function ($event) {
                    return _vm.setSelectedTemplateMessage(
                      $event.target.value,
                      _vm.selectedTemplateId
                    )
                  },
                },
              },
              [
                _c(
                  "option",
                  {
                    attrs: { "data-test": "template-option-none" },
                    domProps: { value: null },
                  },
                  [_vm._v("指定なし")]
                ),
                _vm._v(" "),
                _vm._l(_vm.templates, function (template, i) {
                  return _c(
                    "option",
                    {
                      key: i,
                      attrs: { "data-test": "template-option-" + i },
                      domProps: { value: template.id },
                    },
                    [_vm._v(_vm._s(template.name) + "\n          ")]
                  )
                }),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c(
            "dd",
            { staticClass: "boss-scout-send-right" },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.message.subject,
                    expression: "message.subject",
                  },
                ],
                staticClass: "boss-send-subject",
                class: {
                  "is-invalid-input": _vm.hasTemplateReplacementCharacters(
                    _vm.message.subject
                  ),
                },
                attrs: { type: "text", "data-test": "message-subject" },
                domProps: { value: _vm.message.subject },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.message, "subject", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _vm.hasTemplateReplacementCharacters(_vm.message.subject)
                ? _c("validation-label", {
                    attrs: {
                      "data-test":
                        "has-template-replacement-characters-subject",
                      label:
                        "「●●【」または「】●●」が入力フォームに残っていると、送信することができません",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _c(
            "dd",
            { staticClass: "boss-scout-send-right" },
            [
              _c("div", { staticClass: "boss-textarea-button" }, [
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: {
                          content:
                            "本文にカーソルを合わせてクリックすると、■USER_NAME■ 様 と挿入されます。メッセージ送信時に自動的に応募者名に変換されます。",
                        },
                        expression:
                          "{ content: '本文にカーソルを合わせてクリックすると、■USER_NAME■ 様 と挿入されます。メッセージ送信時に自動的に応募者名に変換されます。'}",
                      },
                    ],
                    staticClass: "boss-button",
                    attrs: { "data-test": "user-name" },
                    on: {
                      click: function ($event) {
                        return _vm.insertionValue("■USER_NAME■ 様")
                      },
                    },
                  },
                  [_vm._v("応募者名を挿入")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: {
                          content:
                            "本文にカーソルを合わせてクリックすると、■JOB_NAME■ と挿入されます。メッセージ送信時に自動的に応募求人名に変換されます。",
                        },
                        expression:
                          "{ content: '本文にカーソルを合わせてクリックすると、■JOB_NAME■ と挿入されます。メッセージ送信時に自動的に応募求人名に変換されます。'}",
                      },
                    ],
                    staticClass: "boss-button",
                    attrs: { "data-test": "job-name" },
                    on: {
                      click: function ($event) {
                        return _vm.insertionValue("■JOB_NAME■")
                      },
                    },
                  },
                  [_vm._v("求人名を挿入")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: {
                          content:
                            "本文にカーソルを合わせてクリックすると、社名が挿入されます。",
                        },
                        expression:
                          "{ content: '本文にカーソルを合わせてクリックすると、社名が挿入されます。'}",
                      },
                    ],
                    staticClass: "boss-button",
                    attrs: { "data-test": "company-name" },
                    on: {
                      click: function ($event) {
                        return _vm.insertionValue(
                          _vm.currentUser.companyUserDisplayName
                        )
                      },
                    },
                  },
                  [_vm._v("社名を挿入")]
                ),
                _c("span", { staticStyle: { "font-size": ".8125rem" } }, [
                  _vm._v("（本文にのみ有効）"),
                ]),
              ]),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.message.body,
                    expression: "message.body",
                  },
                ],
                ref: "message",
                staticClass: "boss-send-textarea",
                class: {
                  "is-invalid-input": _vm.hasTemplateReplacementCharacters(
                    _vm.message.body
                  ),
                },
                attrs: { "data-test": "message-body", rows: "", cols: "" },
                domProps: { value: _vm.message.body },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.message, "body", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _vm.hasTemplateReplacementCharacters(_vm.message.body)
                ? _c("validation-label", {
                    attrs: {
                      "data-test": "has-template-replacement-characters-body",
                      label:
                        "「●●【」または「】●●」が入力フォームに残っていると、送信することができません",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("dt", { staticClass: "boss-scout-send-left" }, [
            _vm._v("添付ファイル（任意）\n      "),
          ]),
          _vm._v(" "),
          _c(
            "dd",
            {
              staticClass: "boss-scout-send-right pega-message-tempfile-height",
            },
            [
              _vm.canFileUpload
                ? [
                    _c(
                      "label",
                      {
                        staticClass: "boss-button boss-send-file",
                        class: { "boss-send-file-disabled": _vm.isOverFiles },
                        attrs: { "data-test": "file-label" },
                      },
                      [
                        _c("input", {
                          ref: "fileUpload",
                          attrs: {
                            type: "file",
                            multiple: "multiple",
                            disabled: _vm.isOverFiles,
                            accept: _vm.acceptTypes.toString(),
                            "data-test": "file-upload",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeFile($event.target.files)
                            },
                          },
                        }),
                        _vm._v("ファイルを選択\n          "),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "boss-send-file-text" },
                      [
                        _vm.isUpload
                          ? _c("span", [_vm._v("アップロード中")])
                          : _vm._l(_vm.message.files, function (file, i) {
                              return _c(
                                "li",
                                {
                                  key: i,
                                  staticClass: "boss-send-file-text-item",
                                },
                                [
                                  _vm._v(_vm._s(file.name)),
                                  _c("span", {
                                    staticClass: "delete-icon",
                                    attrs: { "data-test": "delete-icon-" + i },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeFile(i)
                                      },
                                    },
                                  }),
                                ]
                              )
                            }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _vm._m(2),
                  ]
                : _c("div", { attrs: { "data-test": "not-file-upload" } }, [
                    _vm._v(
                      "\n          6名以上の一括送信にはファイル添付ができません。\n        "
                    ),
                  ]),
            ],
            2
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "boss-layout-block" }, [
        _c("div", { staticClass: "boss-accordion-table-head" }, [
          _c("label", [_vm._v("選考日時ご案内フォーマット")]),
          _vm._v(" "),
          _c("label", { staticClass: "pega-input" }, [
            _c("input", {
              staticClass: "boss-input-checkbox",
              attrs: { type: "radio" },
              domProps: { checked: _vm.useSelectionFormat },
              on: {
                change: function ($event) {
                  return _vm.toggleUseSelectionFormat(true)
                },
              },
            }),
            _vm._v("利用する"),
          ]),
          _vm._v(" "),
          _c("label", { staticClass: "pega-input" }, [
            _c("input", {
              staticClass: "boss-input-checkbox",
              attrs: { type: "radio" },
              domProps: { checked: !_vm.useSelectionFormat },
              on: {
                change: function ($event) {
                  return _vm.toggleUseSelectionFormat(false)
                },
              },
            }),
            _vm._v("利用しない\n      "),
          ]),
          _vm._v(" "),
          _vm.hasCandidateDate
            ? _c("span", { staticClass: "boss-notice-label" }, [
                _vm._v("応募時点の面接希望日あり"),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "boss-table-2",
            attrs: { disabled: !_vm.useSelectionFormat },
            on: {
              click: function ($event) {
                return _vm.toggleUseSelectionFormat(true)
              },
            },
          },
          [
            _c("div", { staticClass: "boss-table-2-layout" }, [
              _c(
                "div",
                { staticClass: "boss-table-2-item boss-table-2-item-head" },
                [_vm._v("候補日時")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "boss-table-2-item boss-table-2-item-body boss-table-2-item-body-has-child",
                },
                [
                  _c("div", { staticClass: "boss-table-2-layout" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "boss-table-2-item boss-table-2-item-head boss-table-2-item-head-compact candidate-head",
                      },
                      [_vm._v("応募者の希望日時")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "boss-table-2-item boss-table-2-item-body js-check-default-cell",
                      },
                      [
                        _c("div", [
                          _c("div", { staticClass: "boss-layout-block" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "boss-layout boss-layout-mobile-wrap boss-layout-start boss-layout-center",
                              },
                              [
                                _c(
                                  "div",
                                  [
                                    _vm.hopeInterviewDate.isHopeOtherDate
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              attrs: {
                                                "data-test":
                                                  "text-hope-interview-other-dates",
                                              },
                                            },
                                            [_vm._v("他の日程を希望する")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            {
                                              directives: [
                                                {
                                                  name: "tooltip",
                                                  rawName: "v-tooltip",
                                                  value: {
                                                    content:
                                                      "応募時点で応募者に表示されている日程は、「一次面接候補日程設定」で設定された日程のうち、応募時点からご指定の表示日程で換算して10日間です。",
                                                  },
                                                  expression:
                                                    "{ content: '応募時点で応募者に表示されている日程は、「一次面接候補日程設定」で設定された日程のうち、応募時点からご指定の表示日程で換算して10日間です。'}",
                                                },
                                              ],
                                              staticClass: "pega-circle",
                                            },
                                            [
                                              _vm._v(
                                                "\n                          ?\n                        "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("label", [
                                            _vm._v(
                                              "※応募時点で応募者に表示されている日程では都合があわないため、別途メッセージで調整をお願いします"
                                            ),
                                          ]),
                                        ]
                                      : _vm.hopeInterviewDateLabels.length
                                      ? _c(
                                          "div",
                                          [
                                            _vm._l(
                                              _vm.hopeInterviewDateLabels,
                                              function (
                                                hopeInterviewDateLabel,
                                                i
                                              ) {
                                                return [
                                                  _c(
                                                    "label",
                                                    {
                                                      key: i,
                                                      attrs: {
                                                        "data-test":
                                                          "hope-date-" + i,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                            " +
                                                          _vm._s(
                                                            hopeInterviewDateLabel
                                                          ) +
                                                          "\n                          "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              }
                                            ),
                                          ],
                                          2
                                        )
                                      : _c(
                                          "div",
                                          {
                                            attrs: {
                                              "data-test":
                                                "no-hope-date-and-note",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                        なし\n                      "
                                            ),
                                          ]
                                        ),
                                    _vm._v(" "),
                                    _vm.hopeInterviewDate.note
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "margin-top-1",
                                            attrs: { "data-test": "hope-note" },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.hopeInterviewDate.note)
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                              ]
                            ),
                          ]),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "boss-table-2-layout" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "boss-table-2-item boss-table-2-item-head boss-table-2-item-head-compact candidate-head",
                      },
                      [_vm._v("第一候補")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "boss-table-2-item boss-table-2-item-body js-check-default-cell",
                      },
                      [
                        _c("div", [
                          _c("div", { staticClass: "boss-layout-block" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "boss-layout boss-layout-mobile-wrap boss-layout-start boss-layout-center",
                              },
                              [
                                _c("div", [
                                  _c(
                                    "label",
                                    {
                                      class: {
                                        "pega-input": _vm.hasCandidateDate,
                                      },
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.firstCandidateStatus,
                                            expression: "firstCandidateStatus",
                                          },
                                        ],
                                        staticClass: "boss-input-checkbox",
                                        attrs: {
                                          disabled: !_vm.hasCandidateDate,
                                          type: "radio",
                                          name: "schedule-1",
                                          checked: "checked",
                                          "data-test":
                                            "first-candidate-radio-first",
                                        },
                                        domProps: {
                                          value: 1,
                                          checked: _vm._q(
                                            _vm.firstCandidateStatus,
                                            1
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            _vm.firstCandidateStatus = 1
                                          },
                                        },
                                      }),
                                      _vm._v(
                                        "応募者が提示している日程から選ぶ\n                      "
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.firstCandidateDateSelect,
                                          expression:
                                            "firstCandidateDateSelect",
                                        },
                                      ],
                                      staticClass: "boss-input-select",
                                      class: {
                                        "pega-empty-select required no-gray":
                                          _vm.isEmptySelect(
                                            _vm.firstCandidateDateSelect
                                          ),
                                      },
                                      attrs: {
                                        disabled:
                                          !_vm.hasCandidateDate ||
                                          _vm.firstCandidateStatus !== 1,
                                        "data-test":
                                          "first-candidate-select-date",
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$selectedVal =
                                            Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function (o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function (o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                          _vm.firstCandidateDateSelect = $event
                                            .target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        },
                                      },
                                    },
                                    [
                                      !_vm.hasCandidateDate
                                        ? _c(
                                            "option",
                                            {
                                              attrs: {
                                                "data-test":
                                                  "first-candidate-day-none",
                                              },
                                              domProps: { value: null },
                                            },
                                            [_vm._v("指定なし")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.hasCandidateDate
                                        ? _c(
                                            "option",
                                            {
                                              attrs: {
                                                "data-test":
                                                  "first-candidate-day-top",
                                              },
                                              domProps: { value: "" },
                                            },
                                            [_vm._v("日付を選択する")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.candidateDateOptions,
                                        function (option, i) {
                                          return _c(
                                            "option",
                                            {
                                              key: i,
                                              attrs: {
                                                "data-test":
                                                  "first-candidate-date-" + i,
                                              },
                                              domProps: { value: option.value },
                                            },
                                            [_vm._v(_vm._s(option.name))]
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.firstCandidateTimeSelect,
                                          expression:
                                            "firstCandidateTimeSelect",
                                        },
                                      ],
                                      staticClass: "boss-input-select",
                                      class: {
                                        "pega-empty-select required no-gray":
                                          _vm.isEmptySelect(
                                            _vm.firstCandidateTimeSelect
                                          ),
                                      },
                                      attrs: {
                                        disabled:
                                          !_vm.hasCandidateDate ||
                                          _vm.firstCandidateStatus !== 1,
                                        "data-test":
                                          "first-candidate-select-time",
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$selectedVal =
                                            Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function (o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function (o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                          _vm.firstCandidateTimeSelect = $event
                                            .target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        },
                                      },
                                    },
                                    [
                                      !_vm.hasCandidateDate
                                        ? _c(
                                            "option",
                                            {
                                              attrs: {
                                                "data-test":
                                                  "first-candidate-time-none",
                                              },
                                              domProps: { value: null },
                                            },
                                            [_vm._v("指定なし")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.hasCandidateDate
                                        ? _c(
                                            "option",
                                            {
                                              attrs: {
                                                "data-test":
                                                  "first-candidate-time-top",
                                              },
                                              domProps: { value: "" },
                                            },
                                            [_vm._v("時間を選択する")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.firstCandidateTimeOptions,
                                        function (option, i) {
                                          return _c(
                                            "option",
                                            {
                                              key: i,
                                              attrs: {
                                                "data-test":
                                                  "first-candidate-time-" + i,
                                              },
                                              domProps: { value: option.value },
                                            },
                                            [_vm._v(_vm._s(option.name))]
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "boss-layout boss-layout-mobile-wrap boss-layout-start boss-layout-center",
                            },
                            [
                              _c("div", [
                                _c("label", { staticClass: "pega-input" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.firstCandidateStatus,
                                        expression: "firstCandidateStatus",
                                      },
                                    ],
                                    staticClass: "boss-input-checkbox",
                                    attrs: {
                                      type: "radio",
                                      name: "schedule-1",
                                    },
                                    domProps: {
                                      value: 2,
                                      checked: _vm._q(
                                        _vm.firstCandidateStatus,
                                        2
                                      ),
                                    },
                                    on: {
                                      change: function ($event) {
                                        _vm.firstCandidateStatus = 2
                                      },
                                    },
                                  }),
                                  _vm._v(
                                    "その他候補日時を入力\n                    "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  _c("date-picker", {
                                    class: {
                                      "pega-empty-select required":
                                        _vm.isEmptySelect(
                                          _vm.firstCandidateInput
                                        ),
                                    },
                                    style: { width: "auto" },
                                    attrs: {
                                      disabled: _vm.firstCandidateStatus !== 2,
                                      "minute-step": 10,
                                      type: "datetime",
                                      "value-type": "YYYY-MM-DDTHH:mm",
                                      "disabled-date": _vm.notBeforeToday,
                                      "disabled-time": _vm.notNightTime,
                                      editable: false,
                                      "default-value":
                                        _vm.defaultValueInDaytime,
                                      format: "YYYY/MM/DD HH:mm",
                                      "input-class": "pega-picker",
                                      placeholder: "日時を選択",
                                      open: _vm.open.firstCandidate,
                                      "data-test": "first-candidate-datetime",
                                    },
                                    on: {
                                      "update:open": function ($event) {
                                        return _vm.$set(
                                          _vm.open,
                                          "firstCandidate",
                                          $event
                                        )
                                      },
                                      change: _vm.handleChangeFirstCandidate,
                                    },
                                    model: {
                                      value: _vm.firstCandidateInput,
                                      callback: function ($$v) {
                                        _vm.firstCandidateInput = $$v
                                      },
                                      expression: "firstCandidateInput",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "boss-table-2-layout" }, [
                    _vm._m(3),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "boss-table-2-item boss-table-2-item-body js-check-default-cell",
                      },
                      [
                        _c("div", [
                          _c("div", { staticClass: "boss-layout-block" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "boss-layout boss-layout-mobile-wrap boss-layout-start boss-layout-center",
                              },
                              [
                                _c("div", [
                                  _c(
                                    "label",
                                    {
                                      class: {
                                        "pega-input": _vm.hasCandidateDate,
                                      },
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.secondCandidateStatus,
                                            expression: "secondCandidateStatus",
                                          },
                                        ],
                                        staticClass: "boss-input-checkbox",
                                        attrs: {
                                          disabled: !_vm.hasCandidateDate,
                                          type: "radio",
                                          name: "schedule-2",
                                          "data-test":
                                            "second-candidate-radio-first",
                                        },
                                        domProps: {
                                          value: 1,
                                          checked: _vm._q(
                                            _vm.secondCandidateStatus,
                                            1
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            _vm.secondCandidateStatus = 1
                                          },
                                        },
                                      }),
                                      _vm._v(
                                        "応募者が提示している日程から選ぶ\n                      "
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.secondCandidateDateSelect,
                                          expression:
                                            "secondCandidateDateSelect",
                                        },
                                      ],
                                      staticClass: "boss-input-select",
                                      class: {
                                        "pega-empty-select required no-gray":
                                          _vm.isEmptySelect(
                                            _vm.secondCandidateDateSelect
                                          ),
                                      },
                                      attrs: {
                                        disabled:
                                          !_vm.hasCandidateDate ||
                                          _vm.secondCandidateStatus !== 1,
                                        "data-test":
                                          "second-candidate-select-date",
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$selectedVal =
                                            Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function (o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function (o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                          _vm.secondCandidateDateSelect = $event
                                            .target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        },
                                      },
                                    },
                                    [
                                      !_vm.hasCandidateDate
                                        ? _c(
                                            "option",
                                            {
                                              attrs: {
                                                "data-test":
                                                  "second-candidate-day-none",
                                              },
                                              domProps: { value: null },
                                            },
                                            [_vm._v("指定なし")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.hasCandidateDate
                                        ? _c(
                                            "option",
                                            {
                                              attrs: {
                                                "data-test":
                                                  "second-candidate-day-top",
                                              },
                                              domProps: { value: "" },
                                            },
                                            [_vm._v("日付を選択する")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.candidateDateOptions,
                                        function (option, i) {
                                          return _c(
                                            "option",
                                            {
                                              key: i,
                                              attrs: {
                                                "data-test":
                                                  "second-candidate-date-" + i,
                                              },
                                              domProps: { value: option.value },
                                            },
                                            [_vm._v(_vm._s(option.name))]
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.secondCandidateTimeSelect,
                                          expression:
                                            "secondCandidateTimeSelect",
                                        },
                                      ],
                                      staticClass: "boss-input-select",
                                      class: {
                                        "pega-empty-select required no-gray":
                                          _vm.isEmptySelect(
                                            _vm.secondCandidateTimeSelect
                                          ),
                                      },
                                      attrs: {
                                        disabled:
                                          !_vm.hasCandidateDate ||
                                          _vm.secondCandidateStatus !== 1,
                                        "data-test":
                                          "second-candidate-select-time",
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$selectedVal =
                                            Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function (o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function (o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                          _vm.secondCandidateTimeSelect = $event
                                            .target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        },
                                      },
                                    },
                                    [
                                      !_vm.hasCandidateDate
                                        ? _c(
                                            "option",
                                            {
                                              attrs: {
                                                "data-test":
                                                  "second-candidate-time-none",
                                              },
                                              domProps: { value: null },
                                            },
                                            [_vm._v("指定なし")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.hasCandidateDate
                                        ? _c(
                                            "option",
                                            {
                                              attrs: {
                                                "data-test":
                                                  "second-candidate-time-top",
                                              },
                                              domProps: { value: "" },
                                            },
                                            [_vm._v("時間を選択する")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.secondCandidateTimeOptions,
                                        function (option, i) {
                                          return _c(
                                            "option",
                                            {
                                              key: i,
                                              attrs: {
                                                "data-test":
                                                  "second-candidate-time-" + i,
                                              },
                                              domProps: { value: option.value },
                                            },
                                            [_vm._v(_vm._s(option.name))]
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "boss-layout-block" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "boss-layout boss-layout-mobile-wrap boss-layout-start boss-layout-center",
                              },
                              [
                                _c("div", [
                                  _c("label", { staticClass: "pega-input" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.secondCandidateStatus,
                                          expression: "secondCandidateStatus",
                                        },
                                      ],
                                      staticClass: "boss-input-checkbox",
                                      attrs: {
                                        type: "radio",
                                        name: "schedule-2",
                                      },
                                      domProps: {
                                        value: 2,
                                        checked: _vm._q(
                                          _vm.secondCandidateStatus,
                                          2
                                        ),
                                      },
                                      on: {
                                        change: function ($event) {
                                          _vm.secondCandidateStatus = 2
                                        },
                                      },
                                    }),
                                    _vm._v(
                                      "その他候補日時を入力\n                      "
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  [
                                    _c("date-picker", {
                                      class: {
                                        "pega-empty-select required":
                                          _vm.isEmptySelect(
                                            _vm.secondCandidateInput
                                          ),
                                      },
                                      style: { width: "auto" },
                                      attrs: {
                                        disabled:
                                          _vm.secondCandidateStatus !== 2,
                                        "minute-step": 10,
                                        type: "datetime",
                                        "disabled-date": _vm.notBeforeToday,
                                        "disabled-time": _vm.notNightTime,
                                        editable: false,
                                        "default-value":
                                          _vm.defaultValueInDaytime,
                                        "value-type": "YYYY-MM-DDTHH:mm",
                                        format: "YYYY/MM/DD HH:mm",
                                        "input-class": "pega-picker",
                                        placeholder: "日時を選択",
                                        open: _vm.open.secondCandidate,
                                        "data-test":
                                          "second-candidate-datetime",
                                      },
                                      on: {
                                        "update:open": function ($event) {
                                          return _vm.$set(
                                            _vm.open,
                                            "secondCandidate",
                                            $event
                                          )
                                        },
                                        change: _vm.handleChangeSecondCandidate,
                                      },
                                      model: {
                                        value: _vm.secondCandidateInput,
                                        callback: function ($$v) {
                                          _vm.secondCandidateInput = $$v
                                        },
                                        expression: "secondCandidateInput",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "boss-layout boss-layout-start boss-layout-center",
                            },
                            [
                              _c("div", [
                                _c("label", { staticClass: "pega-input" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.secondCandidateStatus,
                                        expression: "secondCandidateStatus",
                                      },
                                    ],
                                    staticClass: "boss-input-checkbox",
                                    attrs: {
                                      type: "radio",
                                      checked: "checked",
                                      name: "schedule-2",
                                    },
                                    domProps: {
                                      value: 3,
                                      checked: _vm._q(
                                        _vm.secondCandidateStatus,
                                        3
                                      ),
                                    },
                                    on: {
                                      change: function ($event) {
                                        _vm.secondCandidateStatus = 3
                                      },
                                    },
                                  }),
                                  _vm._v("指定なし\n                    "),
                                ]),
                              ]),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "boss-table-2-layout" }, [
              _c(
                "div",
                { staticClass: "boss-table-2-item boss-table-2-item-head" },
                [_vm._v("所要時間")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "boss-table-2-item boss-table-2-item-body" },
                [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.message.schedule.duration,
                          expression: "message.schedule.duration",
                        },
                      ],
                      staticClass: "boss-input-select",
                      attrs: { "data-test": "duration" },
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.message.schedule,
                            "duration",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                      },
                    },
                    _vm._l(_vm.minutesOptions, function (option, i) {
                      return _c(
                        "option",
                        {
                          key: i,
                          attrs: { "data-test": "duration-option-" + i },
                          domProps: { value: option },
                        },
                        [_vm._v(_vm._s(option) + "\n            ")]
                      )
                    }),
                    0
                  ),
                  _vm._v(" 分\n        "),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "boss-table-2-layout" }, [
              _c(
                "div",
                { staticClass: "boss-table-2-item boss-table-2-item-head" },
                [_vm._v("場所（任意）")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "boss-table-2-item boss-table-2-item-body" },
                [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.message.schedule.place,
                          expression: "message.schedule.place",
                        },
                      ],
                      staticClass: "boss-input-select width-75",
                      class: {
                        "pega-empty-select no-gray":
                          _vm.message.schedule.place === null,
                      },
                      attrs: { "data-test": "place" },
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.message.schedule,
                            "place",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                      },
                    },
                    [
                      _c(
                        "option",
                        {
                          attrs: { "data-test": "empty-place" },
                          domProps: { value: null },
                        },
                        [_vm._v("面接場所を選択してください")]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.interviewPlaces, function (interviewPlace, i) {
                        return _c(
                          "option",
                          {
                            key: i,
                            attrs: { "data-test": "place-option-" + i },
                            domProps: { value: interviewPlace.placeId },
                          },
                          [
                            _vm._v(
                              _vm._s(interviewPlace.placeName) +
                                "\n            "
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("entry-interview-place-modal", {
                    attrs: { "is-disabled": !_vm.useSelectionFormat },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "boss-table-2-layout" }, [
              _vm._m(4),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "boss-table-2-item boss-table-2-item-body width-100",
                },
                [
                  _c("div", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "boss-layout boss-layout-start boss-layout-gap-large boss-layout-wrap",
                      },
                      [
                        _vm._l(
                          _vm.interviewContentsMaster,
                          function (interviewContent, i) {
                            return _c(
                              "label",
                              {
                                key: i,
                                staticClass: "pega-input",
                                attrs: { "data-test": "content-" + i },
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.message.schedule.contentIds,
                                      expression: "message.schedule.contentIds",
                                    },
                                  ],
                                  staticClass: "boss-input-checkbox",
                                  attrs: {
                                    "data-test": "input-content-" + i,
                                    type: "checkbox",
                                  },
                                  domProps: {
                                    value: interviewContent.id,
                                    checked: Array.isArray(
                                      _vm.message.schedule.contentIds
                                    )
                                      ? _vm._i(
                                          _vm.message.schedule.contentIds,
                                          interviewContent.id
                                        ) > -1
                                      : _vm.message.schedule.contentIds,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a = _vm.message.schedule.contentIds,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = interviewContent.id,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.message.schedule,
                                              "contentIds",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.message.schedule,
                                              "contentIds",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(
                                          _vm.message.schedule,
                                          "contentIds",
                                          $$c
                                        )
                                      }
                                    },
                                  },
                                }),
                                _vm._v(
                                  _vm._s(interviewContent.name) +
                                    "\n              "
                                ),
                              ]
                            )
                          }
                        ),
                        _vm._v(" "),
                        _c("label", { staticClass: "pega-input" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.isOtherContents,
                                expression: "isOtherContents",
                              },
                            ],
                            staticClass: "boss-input-checkbox",
                            attrs: {
                              type: "checkbox",
                              "data-test": "other-content",
                            },
                            domProps: {
                              checked: Array.isArray(_vm.isOtherContents)
                                ? _vm._i(_vm.isOtherContents, null) > -1
                                : _vm.isOtherContents,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.isOtherContents,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.isOtherContents = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.isOtherContents = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.isOtherContents = $$c
                                }
                              },
                            },
                          }),
                          _vm._v("その他\n                "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.otherContents,
                                expression: "otherContents",
                              },
                            ],
                            staticClass: "boss-input",
                            class: {
                              "pega-empty-select required":
                                _vm.isEmptySelect(_vm.otherContents) &&
                                _vm.isOtherContents,
                            },
                            attrs: {
                              disabled: !_vm.isOtherContents,
                              type: "text",
                              "data-test": "message-other-content",
                              size: "30",
                              placeholder: "その他を選択した場合は入力必須",
                            },
                            domProps: { value: _vm.otherContents },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.otherContents = $event.target.value
                              },
                            },
                          }),
                        ]),
                      ],
                      2
                    ),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "boss-table-2-layout" }, [
              _c(
                "div",
                { staticClass: "boss-table-2-item boss-table-2-item-head" },
                [_vm._v("備考（任意）")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "boss-table-2-item boss-table-2-item-body" },
                [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.message.schedule.remarks,
                        expression: "message.schedule.remarks",
                      },
                    ],
                    staticClass: "boss-textarea-in-table-2",
                    attrs: {
                      "data-test": "message-remarks",
                      placeholder: "持ち物、到着時の連絡先など",
                    },
                    domProps: { value: _vm.message.schedule.remarks },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.message.schedule,
                          "remarks",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]
              ),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "boss-layout-block" }, [
        _c("div", { staticClass: "boss-table-wrap" }, [
          _c("div", { staticClass: "boss-table-2" }, [
            _c(
              "div",
              { staticClass: "boss-table-2-layout boss-table-2-layout-half" },
              [
                _c("div", { staticClass: "boss-table-2-layout" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "boss-table-2-item boss-table-2-item-head primary",
                    },
                    [_vm._v("選考フェーズ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "boss-table-2-item boss-table-2-item-body",
                      class: {
                        "pega-empty-select required":
                          _vm.message.isPhaseChange === null,
                      },
                      attrs: { "data-test": "update-phase" },
                    },
                    [
                      _c("div", { staticClass: "pega-input no-gray" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.message.isPhaseChange,
                              expression: "message.isPhaseChange",
                            },
                          ],
                          staticClass: "boss-input-checkbox pega-input-button",
                          attrs: {
                            type: "radio",
                            "data-test": "do-update-phase",
                          },
                          domProps: {
                            value: true,
                            checked: _vm._q(_vm.message.isPhaseChange, true),
                          },
                          on: {
                            change: function ($event) {
                              return _vm.$set(
                                _vm.message,
                                "isPhaseChange",
                                true
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            on: {
                              click: function ($event) {
                                _vm.message.isPhaseChange = true
                              },
                            },
                          },
                          [
                            _c("span", [_vm._v("送信後")]),
                            _vm._v(" "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.message.phaseId,
                                    expression: "message.phaseId",
                                  },
                                ],
                                staticClass: "boss-send-select-template",
                                attrs: {
                                  disabled: !_vm.message.isPhaseChange,
                                  "data-test": "select-update-phase",
                                },
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.message,
                                      "phaseId",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                },
                              },
                              _vm._l(_vm.phases, function (phase, i) {
                                return _c(
                                  "option",
                                  { key: i, domProps: { value: phase.id } },
                                  [
                                    _vm._v(
                                      _vm._s(phase.name) +
                                        "\n                    "
                                    ),
                                  ]
                                )
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _c("span", [_vm._v("に更新する")]),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("label", { staticClass: "pega-input" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.message.isPhaseChange,
                              expression: "message.isPhaseChange",
                            },
                          ],
                          staticClass: "boss-input-checkbox",
                          attrs: {
                            type: "radio",
                            "data-test": "do-not-update-phase",
                          },
                          domProps: {
                            value: false,
                            checked: _vm._q(_vm.message.isPhaseChange, false),
                          },
                          on: {
                            change: function ($event) {
                              return _vm.$set(
                                _vm.message,
                                "isPhaseChange",
                                false
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            attrs: { "data-test": "do-not-update-phase-label" },
                          },
                          [_vm._v("更新しない")]
                        ),
                      ]),
                    ]
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "boss-table-2-layout boss-table-2-layout-half" },
              [
                _c("div", { staticClass: "boss-table-2-layout" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "boss-table-2-item boss-table-2-item-head primary",
                    },
                    [_vm._v("選考ステータス")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "boss-table-2-item boss-table-2-item-body",
                      class: {
                        "pega-empty-select required":
                          _vm.message.isStatusChange === null,
                      },
                      attrs: { "data-test": "update-status" },
                    },
                    [
                      _c("div", { staticClass: "pega-input no-gray" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.message.isStatusChange,
                              expression: "message.isStatusChange",
                            },
                          ],
                          staticClass: "boss-input-checkbox pega-input-button",
                          attrs: {
                            type: "radio",
                            "data-test": "do-update-status",
                          },
                          domProps: {
                            value: true,
                            checked: _vm._q(_vm.message.isStatusChange, true),
                          },
                          on: {
                            change: function ($event) {
                              return _vm.$set(
                                _vm.message,
                                "isStatusChange",
                                true
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            on: {
                              click: function ($event) {
                                _vm.message.isStatusChange = true
                              },
                            },
                          },
                          [
                            _c("span", [_vm._v("送信後")]),
                            _vm._v(" "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.message.statusId,
                                    expression: "message.statusId",
                                  },
                                ],
                                staticClass: "boss-send-select-template",
                                attrs: {
                                  disabled: !_vm.message.isStatusChange,
                                  "data-test": "select-update-status",
                                },
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.message,
                                      "statusId",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                },
                              },
                              [
                                _c("option", { domProps: { value: null } }, [
                                  _vm._v("−"),
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.allStatuses, function (status, i) {
                                  return _c(
                                    "option",
                                    { key: i, domProps: { value: status.id } },
                                    [
                                      _vm._v(
                                        _vm._s(status.name) +
                                          "\n                    "
                                      ),
                                    ]
                                  )
                                }),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("span", [_vm._v("に更新する")]),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("label", { staticClass: "pega-input" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.message.isStatusChange,
                              expression: "message.isStatusChange",
                            },
                          ],
                          staticClass: "boss-input-checkbox",
                          attrs: {
                            type: "radio",
                            "data-test": "do-not-update-status",
                          },
                          domProps: {
                            value: false,
                            checked: _vm._q(_vm.message.isStatusChange, false),
                          },
                          on: {
                            change: function ($event) {
                              return _vm.$set(
                                _vm.message,
                                "isStatusChange",
                                false
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            attrs: {
                              "data-test": "do-not-update-status-label",
                            },
                          },
                          [_vm._v("更新しない")]
                        ),
                      ]),
                    ]
                  ),
                ]),
              ]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm._m(5),
      _vm._v(" "),
      _vm.showCandidateAccept
        ? _c("accept-items", {
            attrs: {
              accepted: _vm.isAccepted,
              "notice-label":
                "以下の日程で面接候補日時を応募者にお送りします。間違いないかご確認ください。",
            },
            on: {
              "update:accepted": function ($event) {
                _vm.isAccepted = $event
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _vm.firstCandidate
                        ? _c("div", { staticClass: "grid-x grid-margin-x" }, [
                            _c(
                              "li",
                              {
                                attrs: {
                                  "data-test": "accept-first-candidate-date",
                                },
                              },
                              [
                                _vm._v(
                                  "\n          候補1：" +
                                    _vm._s(
                                      _vm._f("acceptDateFormat")(
                                        _vm.firstCandidate
                                      )
                                    ) +
                                    "\n        "
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.secondCandidate
                        ? _c("div", { staticClass: "grid-x grid-margin-x" }, [
                            _c(
                              "li",
                              {
                                attrs: {
                                  "data-test": "accept-second-candidate-date",
                                },
                              },
                              [
                                _vm._v(
                                  "\n          候補2：" +
                                    _vm._s(
                                      _vm._f("acceptDateFormat")(
                                        _vm.secondCandidate
                                      )
                                    ) +
                                    "\n        "
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              2209567684
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "boss-layout boss-layout-center" }, [
        _c(
          "button",
          {
            staticClass: "boss-button boss-button-confirm pega-button",
            attrs: { disabled: _vm.hasErrors, "data-test": "confirmation" },
            on: { click: _vm.onConfirmClick },
          },
          [
            _c("span", { staticClass: "boss-button-confirm-text" }, [
              _vm._v("送信内容を確認する"),
            ]),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dt", { staticClass: "boss-scout-send-left" }, [
      _vm._v("\n        件名\n        "),
      _c("small", [_vm._v("（200文字以内）")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dt", { staticClass: "boss-scout-send-left" }, [
      _vm._v("本文"),
      _c("small", [_vm._v("（10000文字以内）")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "boss-text pega-text-line-height" }, [
      _c("div", { staticClass: "margin-top-05" }, [
        _vm._v(
          "\n              ・1度にアップロードできるファイルは最大3ファイル、1ファイルの最大サイズは3MBです。\n            "
        ),
      ]),
      _vm._v(" "),
      _c("div", [
        _vm._v(
          "\n              ・応募者がファイルを閲覧・ダウンロードできる期間は送信日から30日間です。\n            "
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "boss-annotation-text" }, [
        _vm._v(
          "\n              ・応募者側から、メッセージにてファイルを添付することはできません。\n            "
        ),
      ]),
      _vm._v(" "),
      _c("div", [
        _vm._v(
          "\n              ファイル形式（JPEG、JPG、PNG、PDF）のみ利用可能\n            "
        ),
      ]),
      _vm._v(" "),
      _c("div", [
        _vm._v(
          "\n              ファイル名に記号（!$&'()*+,;=%:@/?#~）は使用不可\n            "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "boss-table-2-item boss-table-2-item-head boss-table-2-item-head-compact candidate-head",
      },
      [
        _vm._v("第二候補\n              "),
        _c("br"),
        _vm._v("（任意）\n            "),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "boss-table-2-item boss-table-2-item-head" },
      [
        _vm._v("\n          内容（複数選択可能）\n          "),
        _c("br"),
        _vm._v("（任意）\n        "),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "boss-layout-block" }, [
      _c("p", { staticClass: "boss-text" }, [
        _vm._v(
          "※「選考フェーズ、選考ステータス」は応募者側では表示されません。"
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }